/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Credit_Packs_WaiverInputs */

const en_agb_credit_packs_waiver = /** @type {(inputs: Agb_Credit_Packs_WaiverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before purchasing a credit pack, you will be asked to expressly waive your right of withdrawal. The purchase cannot be completed without this consent.`)
};

const de_agb_credit_packs_waiver = /** @type {(inputs: Agb_Credit_Packs_WaiverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor dem Kauf eines Credit-Pakets werden Sie aufgefordert, ausdruecklich auf Ihr Widerrufsrecht zu verzichten. Ohne diese Zustimmung kann der Kauf nicht abgeschlossen werden.`)
};

const fr_agb_credit_packs_waiver = /** @type {(inputs: Agb_Credit_Packs_WaiverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avant d'acheter un pack de credits, il vous sera demande de renoncer expressement a votre droit de retractation.`)
};

const es_agb_credit_packs_waiver = /** @type {(inputs: Agb_Credit_Packs_WaiverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes de comprar un paquete de creditos, se le pedira que renuncie expresamente a su derecho de desistimiento.`)
};

const it_agb_credit_packs_waiver = /** @type {(inputs: Agb_Credit_Packs_WaiverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima di acquistare un pacchetto di crediti, ti verra chiesto di rinunciare espressamente al tuo diritto di recesso.`)
};

const nl_agb_credit_packs_waiver = /** @type {(inputs: Agb_Credit_Packs_WaiverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voordat u een creditpakket koopt, wordt u gevraagd uitdrukkelijk afstand te doen van uw herroepingsrecht.`)
};

const pl_agb_credit_packs_waiver = /** @type {(inputs: Agb_Credit_Packs_WaiverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przed zakupem paczki kredytow zostaniesz poproszony o wyrazne zrzeczenie sie prawa do odstapienia.`)
};

const fi_agb_credit_packs_waiver = /** @type {(inputs: Agb_Credit_Packs_WaiverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ennen krediittipaketin ostoa sinua pyydetään nimenomaisesti luopumaan peruutusoikeudestasi.`)
};

const da_agb_credit_packs_waiver = /** @type {(inputs: Agb_Credit_Packs_WaiverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For du kober en kreditpakke, bliver du bedt om udtrykkeligt at give afkald pa din fortrydelsesret.`)
};

const sv_agb_credit_packs_waiver = /** @type {(inputs: Agb_Credit_Packs_WaiverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innan du koper ett kreditpaket ombeds du uttryckligen avstaa fran din angerratt.`)
};

/**
* | output |
* | --- |
* | "Before purchasing a credit pack, you will be asked to expressly waive your right of withdrawal. The purchase cannot be completed without this consent." |
*
* @param {Agb_Credit_Packs_WaiverInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_credit_packs_waiver = /** @type {((inputs?: Agb_Credit_Packs_WaiverInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Credit_Packs_WaiverInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_credit_packs_waiver(inputs)
	if (locale === "fr") return fr_agb_credit_packs_waiver(inputs)
	if (locale === "es") return es_agb_credit_packs_waiver(inputs)
	if (locale === "it") return it_agb_credit_packs_waiver(inputs)
	if (locale === "nl") return nl_agb_credit_packs_waiver(inputs)
	if (locale === "pl") return pl_agb_credit_packs_waiver(inputs)
	if (locale === "fi") return fi_agb_credit_packs_waiver(inputs)
	if (locale === "da") return da_agb_credit_packs_waiver(inputs)
	if (locale === "sv") return sv_agb_credit_packs_waiver(inputs)
	return en_agb_credit_packs_waiver(inputs)
});